import { BaseEntity, TEntityCreating } from "@/backend/shared/repository/BaseEntity";

import { ELimitType } from "../../organization/domain/Limit";
import { Permissions } from "../../permission/domain/Permission";
import { EPaymentPlan } from "../data/paymentPlans";

//

export interface IPaymentPlan extends BaseEntity {
  monthlyPrice: number;
  oldPrice?: number;
  available: boolean;
  features: Features;
  usageLimits: UsageLimits;
  description?: string;
  type: EPaymentPlan;
}

export interface Features {
  free: boolean;
  base: boolean;
  baseAnalytics: boolean;
  fullAnalytics: boolean;
  ai: boolean;
}

export type UsageLimits = Record<ELimitType, number | null | false>;

export interface FeatureItem {
  title: string;
  /** Указывает, какие действия открывает данный FeatureItem */
  permissions: Partial<{
    [P in keyof Permissions]: Permissions[P]["action"][];
  }>;
}

//

export type IPaymentPlanCreating = TEntityCreating<IPaymentPlan>;

//

export const FEATURES: Record<keyof Features, FeatureItem> = {
  free: {
    title: "Бесплатный функционал",
    permissions: {
      cabinets: ["view"],
      orders: ["view"],
      products: ["view", "create", "update", "archive"],
    },
  },
  base: {
    title: "Базовый функционал",
    permissions: {
      cabinets: ["archive", "connect", "update", "view"],
      kaspiProducts: ["connect", "parse"],
      offers: ["unlink"],
      orders: ["create", "view"],
      products: ["archive", "create", "update", "view"],
      analytics: [],
    },
  },
  baseAnalytics: {
    title: "Базовая аналитика",
    permissions: {
      analytics: ["reduced-view"],
    },
  },
  fullAnalytics: {
    title: "Полная аналитика",
    permissions: {
      analytics: ["full-view"],
    },
  },
  ai: {
    title: "Искусственный интеллект",
    permissions: {},
  },
};
